import React from 'react';
import { connect } from 'react-redux';
import { initialAction } from '../initialAction';
import { EshopHeader } from '../../components/EshopHeader';
import { BreakpointProvider } from '@next-common/breakpoint';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
const mapStateToProps = (state) => {
    var _a, _b;
    const { eshopHeader, router } = state;
    const isEshopNavAndSearch = !router
        ? eshopHeader.isEshopNavAndSearch
        : router.location.pathname.indexOf('/boutique') !== -1 || router.location.search.indexOf('?landing=') !== -1; // !router is to handle server side where redux router does not exist yet
    const isNotCanopy = eshopHeader.isNotCanopy !== undefined && eshopHeader.isNotCanopy !== null ? eshopHeader.isNotCanopy : true; // in non canopy app (hypernova & next.js) there is no redux router
    return Object.assign(Object.assign({}, eshopHeader), { isEshopNavAndSearch,
        isNotCanopy, displayEshopHeader: router ? (_b = (_a = router.location) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.toggleFiltersAndUniverses : false });
};
const mapDispatchToProps = (dispatch) => ({
    initialAction: (context, baseUrl, preloadedConfig) => dispatch(initialAction(context, baseUrl, preloadedConfig)),
});
const ConnectedEshopHeader = connect(mapStateToProps, mapDispatchToProps)(EshopHeader);
const queryClient = new QueryClient({});
const BreakpointWrappedEshopHeader = () => (React.createElement(QueryClientProvider, { client: queryClient },
    React.createElement(BreakpointProvider, null,
        React.createElement(ConnectedEshopHeader, null))));
export const EshopHeaderContainer = BreakpointWrappedEshopHeader;
